import React from "react";

// Circular badge logo for KJ Grönt och Rent
// Green & black with car + lawn mower icons and "VÄNGE" text.
export const Logo = ({ size = 44, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="KJ Grönt och Rent logotyp"
    >
      <defs>
        <clipPath id="circleClip">
          <circle cx="60" cy="60" r="54" />
        </clipPath>
      </defs>

      {/* Outer ring */}
      <circle cx="60" cy="60" r="58" fill="#0f172a" />
      <circle cx="60" cy="60" r="54" fill="#ffffff" />
      <circle cx="60" cy="60" r="54" fill="none" stroke="#16a34a" strokeWidth="2" />

      {/* Top half: lawn mower */}
      <g transform="translate(28 24)">
        {/* mower body */}
        <rect x="6" y="14" width="38" height="14" rx="3" fill="#16a34a" />
        <rect x="10" y="8" width="22" height="8" rx="2" fill="#0f172a" />
        {/* handle */}
        <path d="M44 18 L60 4" stroke="#0f172a" strokeWidth="3" strokeLinecap="round" />
        {/* wheels */}
        <circle cx="14" cy="30" r="5" fill="#0f172a" />
        <circle cx="38" cy="30" r="5" fill="#0f172a" />
        <circle cx="14" cy="30" r="2" fill="#16a34a" />
        <circle cx="38" cy="30" r="2" fill="#16a34a" />
      </g>

      {/* Divider */}
      <line x1="14" y1="64" x2="106" y2="64" stroke="#16a34a" strokeWidth="1.5" opacity="0.45" />

      {/* Bottom half: car */}
      <g transform="translate(26 68)">
        {/* car body */}
        <path
          d="M4 14 L10 6 H56 L62 14 V20 H4 Z"
          fill="#0f172a"
        />
        <path
          d="M12 8 H30 V14 H12 Z M34 8 H52 V14 H34 Z"
          fill="#ffffff"
          opacity="0.9"
        />
        {/* wheels */}
        <circle cx="16" cy="20" r="4" fill="#16a34a" />
        <circle cx="50" cy="20" r="4" fill="#16a34a" />
      </g>

      {/* VÄNGE text along bottom */}
      <text
        x="60"
        y="108"
        textAnchor="middle"
        fontFamily="'Plus Jakarta Sans', system-ui, sans-serif"
        fontSize="9"
        fontWeight="800"
        letterSpacing="3"
        fill="#0f172a"
      >
        VÄNGE
      </text>
    </svg>
  );
};

export const LogoWithText = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <Logo size={44} />
    <div className="leading-tight">
      <div className="font-extrabold text-slate-900 text-base sm:text-lg tracking-tight">
        KJ Grönt &amp; Rent
      </div>
      <div className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-green-700 font-semibold">
        Vänge
      </div>
    </div>
  </div>
);
